export default __webpack_public_path__ + "static/media/SansWeb-Bold.930dc73e.woff";